// @mui

import {
  Grid,
  Card,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Stack,
} from '@mui/material';

// @types

import { ShopDetail } from 'src/@types/Choqorak/MainTables/Shop/Shop';

//Localization
import useLocales from 'src/hooks/useLocales';

import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';

import HistoryComponent from '../../History/HistoryComponent';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useNavigate } from 'react-router';

type Props = {
  row: ShopDetail;
  electricityRow?: IElectricityPayment[];
  rentRow?: IRentPayment[];
  contractRow?: IContractInfo[];
  clearShop: () => void;
};

export default function ShopDetailTableRow({
  row,
  clearShop,
  electricityRow,
  rentRow,
  contractRow,
}: Props) {
  const { translate } = useLocales(); //Localization

  const SHOP_HEAD = [
    { id: 'shopId', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'shopCode', label: `${translate('Shop.ShopCode')}`, align: 'left' },
    { id: 'floor', label: `${translate('Shop.Floor')}`, align: 'left' },
    { id: 'block', label: `${translate('Shop.Block')}`, align: 'left' },
    { id: 'shopType', label: `${translate('Shop.ShopType')}`, align: 'left' },
    { id: 'shopStatus', label: `${translate('Shop.ShopStatus')}`, align: 'left' },
    { id: 'shopArea', label: `${translate('Shop.ShopArea')}`, align: 'left' },
    { id: 'rentPerMonth', label: `${translate('Shop.RentPerMonth')}`, align: 'left' },
  ];
  const navigate = useNavigate();
  return (
    <>
      <Grid item xs={6} md={6}>
        <Stack direction="row" spacing={1.5} sx={{ mt: 1, ml: 0, mb: 2 }}>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            onClick={() => {
              navigate(PATH_DASHBOARD.Shop.list);
              // clearCustomer();
            }}
          >
            {translate('CRUD.BackToList')}
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 30 }}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {translate('Shop.ShopDetails')}
          </Typography>
          <TableContainer sx={{ minWidth: 720 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {SHOP_HEAD.map((column) => (
                    <TableCell key={column.id}>{column.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="left">{1}</TableCell>
                  <TableCell align="left">{row.shopCode ?? 'N/A'}</TableCell>
                  <TableCell align="left">{row.floorCode ?? 'N/A'}</TableCell>
                  <TableCell align="left">{row.blockName ?? 'N/A'}</TableCell>
                  <TableCell align="left">{row.shopType ?? 'N/A'}</TableCell>
                  <TableCell align="left">{row.shopStatus ?? 'N/A'}</TableCell>
                  <TableCell align="left">
                    {isNaN(Number(row.shopWidth)) || isNaN(Number(row.shopLength))
                      ? 'N/A'
                      : Number(row.shopWidth) * Number(row.shopLength)}
                  </TableCell>

                  <TableCell align="left">{row.rentPerMonth ?? 'N/A'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
      </Grid>
      <HistoryComponent
        electricityRow={electricityRow}
        rentRow={rentRow}
        contractRow={contractRow}
        historyTitle={translate('Shop.Shop')}
      />
    </>
  );
}

//---------------------------------------------
